/* eslint-disable */
import React from 'react';
import classes from './Interpretation.css';

export const Interpretation = props => {
  const { data } = props;
  const pause = data.type.name === 'Pause';
  return (
    <div className={`${classes.interpretation}`}>
      <div className={pause ? classes.interpretationPause : classes.interpretationTitle}>
        {pause ? (
          <React.Fragment>
            <h1>{data.type.name}</h1>
            <span style={{
              marginLeft: '12px',
              marginTop: '6px'
            }}>
              {(data.time.end - data.time.start).toFixed(2)} seconds
            </span>
          </React.Fragment>
        ) : (
          <h1>{data.type.name}</h1>
        )}
      </div>
      {!pause && data.bpm && (
        <div
          className={classes.note}
        >{`#Beats: , AVG:${data.bpm && data.bpm.average}, Range: ${data.bpm && data.bpm.min}-${data.bpm && data.bpm.max} bpm`}</div>
      )}
    </div>
  );
};

export default Interpretation;



// WEBPACK FOOTER //
// ./src/views/components/IDTFRecordingInfoPane/Interpretation/Interpretation.js